import DOMPurify from 'dompurify'

/**
 * Sanitizes HTML content to prevent XSS attacks.
 * Uses DOMPurify to remove potentially dangerous HTML/JavaScript while preserving safe formatting.
 *
 * @param html - The HTML string to sanitize
 * @returns A sanitized HTML string safe for use with v-html
 */
export function sanitizeHtml(html: string): string {
    // DOMPurify requires a DOM, so only sanitize on the client side
    if (import.meta.client && typeof window !== 'undefined') {
        return DOMPurify.sanitize(html, {
            ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'a', 'ul', 'ol', 'li', 'span', 'div'],
            ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
        })
    }
    // Server-side: return with all tags stripped for hydration
    // Client-side sanitization will occur after hydration
    return html.replace(/<[^>]*>?/g, '') || ''
}
